angular.module('shared').controller('FiltersModalCtrl', ["$scope", "$modalInstance", "filters", "options", function($scope, $modalInstance, filters, options) {
  $scope.filters = angular.extend({}, filters);
  $scope.options = options;
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  return $scope.submit = function() {
    return $modalInstance.close($scope.filters);
  };
}]);
